export default {
  namespaced: true,
  state: {
    transitionName: 'slide-right',
    portfolioSliderPosition: 0,
  },
  getters: {
    ['transitionName:get'](state) { return state.transitionName; },
    ['portfolioSliderPosition:get'](state) { return state.portfolioSliderPosition; },
  },
  mutations: {
    ['transitionName:set'](state, transitionName) {
      state.transitionName = transitionName;
    },
    ['portfolioSliderPosition:set'](state, currentSlide) {
      state.portfolioSliderPosition = currentSlide;
    },
  },
  actions: {
    ['transitionName:set']({ commit }, transitionName) {
      commit('transitionName:set', transitionName);
    },
    ['portfolioSliderPosition:set']({ commit }, currentSlide) {
      commit('portfolioSliderPosition:set', currentSlide);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ui/index.js